"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _QuotasRowRecord = _interopRequireDefault(require("./QuotasRowRecord"));

var QuotasTableBaseRecord = (0, _immutable.Record)({
  period: null,
  quotaType: null,
  rows: (0, _immutable.Map)(),
  ownerIds: (0, _immutable.Set)(),
  ownerPipelineIds: (0, _immutable.Map)()
}, 'QuotasTableRecord');

var QuotasTableRecord =
/*#__PURE__*/
function (_QuotasTableBaseRecor) {
  (0, _inherits2.default)(QuotasTableRecord, _QuotasTableBaseRecor);

  function QuotasTableRecord() {
    (0, _classCallCheck2.default)(this, QuotasTableRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(QuotasTableRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(QuotasTableRecord, [{
    key: "getRowKey",
    value: function getRowKey(ownerId, pipelineId) {
      return ownerId + ":" + pipelineId;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.rows.isEmpty();
    }
  }, {
    key: "setQuota",
    value: function setQuota(quota) {
      var quotasTableRecord = this.updateIn(['rows', quota.getRowKey()], new _QuotasRowRecord.default({
        quotaType: this.quotaType,
        period: this.period,
        ownerId: quota.ownerId,
        pipelineId: quota.pipelineId
      }), function (quotasRowRecord) {
        return quotasRowRecord.setQuota(quota);
      }).set('ownerIds', this.ownerIds.add(quota.ownerId));

      if (quota.pipelineId) {
        quotasTableRecord = quotasTableRecord.updateIn(['ownerPipelineIds', quota.ownerId], (0, _immutable.Set)(), function (pipelines) {
          return pipelines.add(quota.pipelineId);
        });
      }

      return quotasTableRecord;
    }
  }, {
    key: "deleteQuota",
    value: function deleteQuota(quota) {
      if (!this.rows.has(quota.getRowKey())) {
        return this;
      }

      var quotasTableRecord = this;
      quotasTableRecord = quotasTableRecord.updateIn(['rows', quota.getRowKey()], function (quotasRowRecord) {
        return quotasRowRecord.deleteQuota(quota);
      });

      if (quotasTableRecord.rows.get(quota.getRowKey()).quotasByStart.isEmpty()) {
        quotasTableRecord = quotasTableRecord.update('rows', function (rows) {
          return rows.delete(quota.getRowKey());
        }).update('ownerIds', function (ownerIds) {
          return ownerIds.delete(quota.ownerId);
        });
      }

      if (quota.pipelineId) {
        quotasTableRecord = quotasTableRecord.updateIn(['ownerPipelineIds', quota.ownerId], function (pipelines) {
          return pipelines.delete(quota.pipelineId);
        });
      }

      return quotasTableRecord;
    }
  }]);
  return QuotasTableRecord;
}(QuotasTableBaseRecord);

exports.default = QuotasTableRecord;
module.exports = exports.default;